import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-64dcfb84"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fl ml14"
}, "Download", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- fr mr10"
}, null, -1));

const _hoisted_3 = [_hoisted_1, _hoisted_2];
const _hoisted_4 = {
  class: "downUl"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconwindows mr10 font12"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Windows", -1));

const _hoisted_7 = [_hoisted_5, _hoisted_6];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconpingguo mr10 font12"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "MAC", -1));

const _hoisted_10 = [_hoisted_8, _hoisted_9];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconlinux mr10 font12"
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Linux", -1));

const _hoisted_13 = [_hoisted_11, _hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["down pointer br4", {
      [_ctx.className]: true
    }])
  }, [_createElementVNode("div", {
    class: "width134 height34 lh34 colorFFF br4",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.show = !_ctx.show, ["stop"]))
  }, _hoisted_3), _createVNode(_component_el_collapse_transition, null, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: "downLi al height38 lh38 pl16 colorFFF",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.down(_ctx.keys, 0), ["stop"]))
    }, _hoisted_7), _createElementVNode("div", {
      class: "downLi al height38 lh38 pl16 colorFFF",
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.down(_ctx.keys, 1), ["stop"]))
    }, _hoisted_10), _createElementVNode("div", {
      class: "downLi al height38 lh38 pl16 colorFFF",
      onClick: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.down(_ctx.keys, 2), ["stop"]))
    }, _hoisted_13)], 512), [[_vShow, _ctx.show]])]),
    _: 1
  })], 2);
}